export const LOGIN = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  START_LOGIN: 'START_LOGIN',
  END_LOGIN: 'END_LOGIN',
  LOGIN_ERROR: 'LOGIN_ERROR',

  START_RESET_ACTION: 'START_RESET_ACTION',
  PASSWORD_RESET_ERROR: 'PASSWORD_RESET_ERROR',
  END_RESET_ACTION: 'END_RESET_ACTION',
  PASSWORD_RESET_USERNAME_ERROR: 'PASSWORD_RESET_USERNAME_ERROR',

  START_METHOD_FETCH: 'START_METHOD_FETCH',
  FETCH_AVAILABLE_METHODS: 'FETCH_AVAILABLE_METHODS',
  END_METHOD_FETCH: 'END_METHOD_FETCH',

  START_VALIDATION_SEND: 'START_VALIDATION_SEND',
  SEND_CODE_VIA_METHOD: 'SEND_CODE_VIA_METHOD',
  END_VALIDATION_SEND: 'END_VALIDATION_SEND',

  START_VALIDATING_CODE: 'START_VALIDATING_CODE',
  CODE_VALIDATION: 'VALIDATED_CODE',
  END_VALIDATING_CODE: 'END_VALIDATING_CODE',

  START_CREDENTIAL_SEND: 'START_CREDENTIAL_SEND',
  FETCH_CREDENTIAL_DATA: 'FETCH_CREDENTIAL_DATA',
  END_CREDENTIAL_SEND: 'END_CREDENTIAL_SEND',

  LOGIN_TERMS_TITLE: 'Terms of Use',
  LOGIN_TERMS_BODY: 'By accepting below terms, I agree that use of this Application is subject to the governing Master Listing and Broker Referral Agreement and Broker Guidelines, and I further agree to complete and return the necessary Xome Agent Network Supplemental to Xome for each assigned lead.',

  ACCEPT_LOGIN_TERMS: 'ACCEPT_LOGIN_TERMS',

  UPDATE_DEVICE_INFO: 'UPDATE_DEVICE_INFO',

  CONTACT_SUPPORT: 'Please contact xomeproagentsupport@xome.com if you need your password reset.',
  FORGOT_YOUR_PASSWORD: 'Enter the username associated with your XomePro account. \n We\'ll send you a code to reset your password.',
  METHOD_OF_DELIVERY: 'Please let us know where we should send your 6-digit verfication code:',
  PASSWORD_UPDATE_SUCCESS: 'Your password has been successfully updated for XomePro, Cascade, and VMS!',
  MESSAGING_DISCLAIMER: '*Messaging and data rates may apply.',
  WRONG_CODE: ' Wrong verfication code. Please try again.',
  USERNAME_ERROR: 'Sorry, this username doesn\'t match what we have on file',
  CODE_MATCH_ERROR: 'The code you entered does not match what we sent. Please try again or tap the resend link for a new code.',
  CODE_EXPIRED: 'The code you entered has expired. Please tap the resend link for a new code.',
  PASSWORD_CHANGED: 'Password updated for XomePro, Cascade, and VMS!',
  SEND_CONFIRMATION: 'Your code has been sent to ',
  CODE_EXPIRED_ERROR: 'The verification code has expired. Please tap the resend link for a new code.',

  SET_FORM_POSITION: 'SET_FORM_POSITION',
  SET_SEND_METHOD: 'SET_SEND_METHOD',
  SET_VALIDATION_CODE: 'SET_VALIDATION_CODE',
  SET_SEND_TIME: 'SET_SEND_TIME ',

  FORM_POSITION: {
    ENTER_USERNAME: 'ENTER_USERNAME',
    ENTER_METHOD: 'ENTER_METHOD',
    ENTER_CODE: 'ENTER_CODE',
    ENTER_PASSWORD: 'ENTER_PASSWORD',
    LOGIN_USER: 'LOGIN_USER'
  },

  ACCOUNT_LOCKED_MSG: 'Your account has been locked because of too many failed attempts. Please call (844) 927-9284 or email us at vendorcertification@xome.com to have your account unlocked.'
};
